<template>
  <div id='historyComment'>
    <a-collapse v-model='activeKey' v-if="!noPanel" :bordered='false'>
<!--      <template  v-slot:expandIcon="props">-->
<!--        <a-icon type="caret-right" :rotate="props.isActive ? -90 : 90" />-->
<!--      </template>-->
      <a-collapse-panel key="1" :style="panelStyle"  :showArrow="false">
        <div slot="header" class="panel_header" >
          <div class="circle"></div>
          <div class="panel_text">{{$t('commission.operationHistory')}}</div>
          <a-icon  type="caret-right" :rotate="this.activeKey.indexOf('1') > -1 ? 90 : -90" style="margin-left: 85%"/>
        </div>
        <a-row v-if="historyComments && historyComments.length > 0">
          <a-row class="operationHistoryHeader">
            <a-col :span="1"></a-col>
            <a-col :span="4">{{$t('commission.operationHistoryTableHeader.type')}}</a-col>
            <a-col :span="8">{{$t('commission.operationHistoryTableHeader.user')}}</a-col>
            <a-col :span="11">{{$t('commission.operationHistoryTableHeader.reason')}}</a-col>
          </a-row>
          <a-row v-for="(item,index) in historyComments" :key="index" class="operationHistoryRows">
            <a-col :span="1">{{ index + 1 }}</a-col>
            <a-col :span="4">{{ item.typeText || (item.comment!= "取消申请" && item.comment!= "提交申请" ? item.comment == "被撤回后重新提交" ? $t('key17chongxintijiao'): $t('approval.result.' + item.result) : item.comment) }}</a-col>
            <a-col :span="8">{{item.userName}}/{{$moment(item.createTime).format('YYYY-MM-DD')}}</a-col>
            <!--        <a-col :span="12" v-if="item.type==5 || item.type==1 || item.type== 8 || item.type== 9"> {{item.comment =='undefined' || item.comment =='null' ? '~' : item.comment}}</a-col>-->
            <!--        <a-col :span="12" v-else-if="item.type == 6">{{$t('commission.reject.freezeCommission')}} : {{item.reasons}}</a-col>-->
            <a-col :span="11" v-html='item.contentText !== undefined ? item.contentText : (item.comment!= "取消申请" &&item.comment!= "提交申请" ?  item.comment : "~")'></a-col>
          </a-row>
        </a-row>
      </a-collapse-panel>
    </a-collapse>
	  <div v-else>
		  <show-title :title="$t('commission.operationHistory')" :show-required="false"></show-title>
		  <div style="background: #FBFBFC;padding: 14px 22px;">
			  <div v-if="historyComments && historyComments.length > 0">
				  <a-row class="operationHistoryHeader_no">
            <a-col :span="1"></a-col>
					  <a-col :span="4">{{$t('commission.operationHistoryTableHeader.type')}}</a-col>
					  <a-col :span="8">{{$t('commission.operationHistoryTableHeader.user')}}</a-col>
					  <a-col :span="11">{{$t('commission.operationHistoryTableHeader.reason')}}</a-col>
				  </a-row>
				  <a-row v-for="(item,index) in historyComments" :key="index" class="operationHistoryRows_no">
            <a-col :span="1">{{ index + 1 }}</a-col>
					  <a-col :span="4">{{ item.typeText || (item.comment!= "取消申请" && item.comment!= "提交申请" ? item.comment == "被撤回后重新提交" ? $t('key17chongxintijiao'): $t('approval.result.' + item.result) : item.comment) }}</a-col>
					  <a-col :span="8">{{item.userName}}/{{$moment(item.createTime).format('YYYY-MM-DD')}}</a-col>
					  <!--        <a-col :span="12" v-if="item.type==5 || item.type==1 || item.type== 8 || item.type== 9"> {{item.comment =='undefined' || item.comment =='null' ? '~' : item.comment}}</a-col>-->
					  <!--        <a-col :span="12" v-else-if="item.type == 6">{{$t('commission.reject.freezeCommission')}} : {{item.reasons}}</a-col>-->
					  <a-col :span="11" v-html='item.contentText !== undefined ? item.contentText : (item.comment!= "取消申请" &&item.comment!= "提交申请" ?  item.comment : "~")'></a-col>
				  </a-row>
			  </div>
		  </div>
	  </div>
  </div>

</template>

<script>
import showTitle from "@/components/showTitle/index.vue";


export default {
  name: 'historyComment',
	components:{
		showTitle
	},
  props:{
    historyComments:[],
	  noPanel:{
			type:Boolean,
		  defautl:false,
	  }
  },
  data(){
    return{
      activeKey:["1"],
      panelStyle: 'background: #FFFFFF;border: 0;margin-bottom:10px !important;',
    }
  }

}
</script>

<style scoped lang='less'>
.panel_header{
  display: flex;
  align-items: center;
  .circle{
    //margin-left: 12px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #FABE00;
  }
  .panel_text{
    padding: 0 10px;
    color: #333333;
    font-size: 12px;
    //font-weight: bold;
  }
}
.operationHistoryHeader{
  font-size: 12px;
  color: #999999;
  padding: 10px 30px;
  //border-bottom: 1px solid #F6F6F6;
}
.operationHistoryRows{
  font-size: 12px;
  color: #333333;
  padding: 10px 30px;
}

.operationHistoryHeader_no{
  font-size: 12px;
  color: #999999;
  //border-bottom: 1px solid #F6F6F6;
	padding: 10px 0px;
}
.operationHistoryRows_no{
  font-size: 12px;
  color: #333333;
	padding: 10px 0px;
}

</style>
<style lang="less">
#historyComment{
  .ant-collapse-borderless > .ant-collapse-item{
    border: 0px !important;
    //margin-left: 10px;
  }
  .ant-collapse-borderless{
    background-color: #ffffff !important;
  }
  .ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box{
    padding: 0;
  }
  .ant-collapse .ant-collapse-item .ant-collapse-header .anticon {
    left: initial;
    right: 16px;
  }
  .ant-collapse > .ant-collapse-item > .ant-collapse-header{
    padding: 12px 0px 12px 0px;
    background: #FAFBFC;
    margin-top: 15px;
  }
  .edit_icon{
    font-size: 18px;
    float:right;
    cursor:pointer;
  }
  .collapse_button{
    position: absolute;
    right:10px;
    top:14px;
  }
}
</style>
